import GridViewCollapase from "src/SharedComponents/GridViewCollapse/GridViewCollapse";
import tableStyles from 'src/Utils/CssModules/table.module.css';
import { IClinic, IUserLicencesInfo } from "src/Utils/Hooks/useGetDistributorInfo/useGetDistributorInfo";
import { formatDateString } from "src/Utils/DateFormatting/DateFormattter";
import Button from "src/SharedComponents/Button/Button";
import { useState } from "react";
import AssignLicenseToClinic from "../../AssignToClinic/AssignLicenseToClinic";
import { useDistributorLicenseServiceWrapper } from "src/Utils/Hooks/LicenseService/useDistributorLicenseServiceWrapper";
import { LicenseType } from "src/Utils/Hooks/LicenseService/useDistributorLicenseService";
import { useTranslation } from "react-i18next";
import { isDateExpired } from "src/Utils/DateExpiry/DateExpiryChecker";

export interface IAuraAppLicensesUnassigned{
    auraAppLicensesUnassigned: IUserLicencesInfo[];
    clinics: IClinic[] | undefined;
    distributorId: string;
}

const AuraAppLicensesUnassigned: React.FC<IAuraAppLicensesUnassigned> = ({auraAppLicensesUnassigned, clinics, distributorId}) => {
    const [showAssignPartner, setShowAssignPartner] = useState<boolean>(false);
    const [entitlementId, setEntitlementId] = useState<string>("");
    const {assignLicenseClinic} = useDistributorLicenseServiceWrapper();
    const {t} = useTranslation();

    return(
        <>
            {
                showAssignPartner && 
                <AssignLicenseToClinic
                    onClose={() => {setShowAssignPartner(false)}}
                    onSubmit={(clinicId: string, clinicName: string) => {
                        assignLicenseClinic(LicenseType.AuraAppLicenses, clinicId, entitlementId, clinicName, distributorId)
                        setShowAssignPartner(false);
                    }}
                    entitlementId={entitlementId}
                    clinics={clinics}
                    licenseType={t('App')}
                />
            }
            <GridViewCollapase title={t('OnStock')} id="aura-app-licenses-unassigned">
                <div>
                    <table style={{ width: '100%' }} data-testid="table" className={`table ${tableStyles.tableStriped}`}>
                        <thead className={`${tableStyles.tableHead}`}>
                            <tr key={'header'}>
                                <th className={tableStyles.heading} style={{width: '29%', paddingTop: '0px', paddingLeft: '25px'}}>{t('EntitlementId')}</th>
                                <th className={tableStyles.heading} style={{width: '20%', paddingTop: '0px'}}>{t('LicenseType')}</th>
                                <th className={tableStyles.heading} style={{width: '15%', paddingTop: '0px'}}>{t('ExpirationDate')}</th>
                                <th className={tableStyles.heading} style={{width: '16%', paddingTop: '0px'}}>{t('Seats')}</th>
                                <th style={{width: '20%', paddingTop: '0px'}}></th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                auraAppLicensesUnassigned && auraAppLicensesUnassigned.map((license: IUserLicencesInfo, index: number) => (
                                    <tr key={index}>
                                        <td className={`${tableStyles.data} ${tableStyles.suiteValue}`} style={{paddingLeft: '25px'}}>{license?.entitlementId}</td>
                                        <td className={tableStyles.data}>{license?.licenseType}</td>
                                        <td className={tableStyles.data} style={isDateExpired(license?.licenseEndDate) ? {color: 'red'} : {}}>{license?.licenseType.toLowerCase().includes("permanent") ? '-' : (license?.licenseEndDate ? formatDateString(license?.licenseEndDate) : '-')}</td>
                                        <td className={tableStyles.data}>{license?.maximumSeats}</td>
                                        <td className={tableStyles.data}></td>
                                        <td className={tableStyles.data} style={{textAlign: 'end'}}>
                                            <Button
                                                backgroundColor="#ffffff"
                                                color="var(--UI-Colors-Primary)"
                                                text={t('AssignToClinic')}
                                                borderColor="var(--UI-Colors-Primary)"
                                                fontSize="12px"
                                                width='172px'
                                                fontWeight='600'
                                                disable={false}
                                                onClick={() => {setEntitlementId(license?.entitlementId);setShowAssignPartner(true)}}
                                            />
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
            </GridViewCollapase>
        </>
    );
}

export default AuraAppLicensesUnassigned;